import React, { useState, useEffect } from 'react';
import { Container, Typography, TextField, Card, CardContent, Button, Stack } from '@mui/material';
// import { saveCompanyData, getCompanyData } from '../services/companyService';
import { useAuth } from '../../contexts/AuthContext';
import { useCompany } from '../../contexts/CompanyContext';
import IntegerField from '../../components/Custom/IntegerField';

const BasicInfoPage = () => {
  const {company, updateCompany} = useCompany();
  console.log('DEBUG company',company)
  const { currentUser } = useAuth();
  const [companyData, setCompanyData] = useState({
    name: '',
    logoUrl: '',
    bannerUrl: '',
    mission: '',
    vision: '',
    values: '',
    goals: '',
    internalPolicies: '',
    rules: '',
    employee: [],
    variableCusts: [],
    fixedCusts: []
  });

  useEffect(() => {
    if (currentUser) {
      console.log('DEBUG company',company)
      setCompanyData(company.company || {})
      console.log('DEBUG companyData',companyData)
    }
  }, [currentUser,company]);

  const handleChange = (e) => {
    setCompanyData({ ...companyData, [e.target.name]: e.target.value });
    console.log('DEBUG company',company)
    console.log('DEBUG companyData',companyData)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentUser) return;
    try {
      await updateCompany({...company, company:companyData, companyId: company.companyId});
      alert('[INFO] Dados da empresa salvos com sucesso!');
    } catch (error) {
      alert('[ERRO] Erro ao salvar dados da empresa.');
      console.error(error);
    }
  };

  return (
    <Container maxWidth="md" >

      <Card sx={{ borderRadius: 3, boxShadow: 2 }}>
        <CardContent>
          <form onSubmit={handleSubmit} noValidate>
            <Stack spacing={3}>
              <TextField
                label="Nome da Empresa"
                name="name"
                value={companyData.name}
                onChange={handleChange}
                required
                fullWidth
              />
              <TextField
                label="Missão"
                name="mission"
                value={companyData.mission}
                onChange={handleChange}
                fullWidth
                multiline
                rows={2}
              />
              <TextField
                label="Visão"
                name="vision"
                value={companyData.vision}
                onChange={handleChange}
                fullWidth
                multiline
                rows={2}
              />
              <TextField
                label="Valores"
                name="values"
                value={companyData.values}
                onChange={handleChange}
                fullWidth
                multiline
                rows={2}
              />
              <IntegerField
                label="Horas semanais"
                name="tempoSemanal"
                value={companyData.tempoSemanal}
                onChange={handleChange}
                placeholder="44"
                required
              />

              <Button variant="contained" type="submit" size="large" sx={{ borderRadius: 3 }}>
                Salvar
              </Button>
            </Stack>
          </form>
        </CardContent>
      </Card>
    </Container>
  );
};

export default BasicInfoPage;
